module.exports = __webpack_public_path__ + "img/round_room.12b3345.webp";